"use client";

import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Shimmer Button — pure framer-motion, no CSS keyframes.
const ShimmerButton = React.forwardRef(
  (
    {
      className,
      children,
      background = "var(--gold)",
      shimmerColor = "rgba(255, 255, 255, 0.55)",
      shimmerDuration = 2.6,
      ...props
    },
    ref,
  ) => (
    <motion.button
      ref={ref}
      style={{ background }}
      whileHover={{ y: -1 }}
      whileTap={{ y: 1, scale: 0.99 }}
      transition={{ duration: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={cn(
        "relative overflow-hidden inline-flex items-center justify-center px-6 py-4 text-navy border border-white/10 whitespace-nowrap",
        className,
      )}
      {...props}
    >
      {/* Shimmer sweep */}
      <motion.span
        aria-hidden
        className="pointer-events-none absolute top-0 bottom-0 w-1/3 skew-x-[-18deg]"
        style={{
          background: `linear-gradient(90deg, transparent, ${shimmerColor}, transparent)`,
        }}
        initial={{ x: "-140%" }}
        animate={{ x: "260%" }}
        transition={{
          duration: shimmerDuration,
          repeat: Infinity,
          ease: [0.65, 0, 0.35, 1],
          repeatDelay: 0.4,
        }}
      />
      <span className="relative z-10 flex items-center">{children}</span>
    </motion.button>
  ),
);
ShimmerButton.displayName = "ShimmerButton";

export { ShimmerButton };
export default ShimmerButton;
